import { ReactNode } from 'react';

import { Box, Drawer, DrawerContent, DrawerOverlay } from '@chakra-ui/react';

import { useDappSDKProvider } from '@/dapp-sdk-v2';

import { AppErrorBoundary } from '../AppErrorBoundary';
import Banner from '../Banner';
import ChatBot from '../ChatBot/ChatBot';
import UserPilot from '../UserPilot';

export interface PageLayoutProps {
  Sidebar: ReactNode;
  MobileSideBar: ReactNode;
  Header: ReactNode;
  children: ReactNode;
}

const PageLayout = ({
  Sidebar,
  Header,
  children,
  MobileSideBar,
}: PageLayoutProps) => {
  const { isBannerVisible, isMobileMenuOpen, setStakeData } =
    useDappSDKProvider();
  const handleClose = () => {
    setStakeData({
      isMobileMenuOpen: false,
    });
  };

  return (
    <>
      <Banner />
      <UserPilot />
      <ChatBot />

      <AppErrorBoundary>
        <Box mt={{ base: 0, lg: isBannerVisible ? '2rem' : 0 }}>
          {Sidebar && Sidebar}
          {MobileSideBar && (
            <Drawer
              isOpen={isMobileMenuOpen}
              placement="left"
              onClose={handleClose}
              returnFocusOnClose={false}
              onOverlayClick={handleClose}
            >
              <DrawerOverlay bg="modalOverlay" />
              <DrawerContent bg="backgroundSecondary">
                {MobileSideBar}
              </DrawerContent>
            </Drawer>
          )}
          {Header && Header}
          <AppErrorBoundary>{children}</AppErrorBoundary>
        </Box>
      </AppErrorBoundary>
    </>
  );
};

export default PageLayout;
